<template>
    <div style="background-color:white">
        <el-row>
            <el-col :xs="24">
                <div style="background-color:#aeaeae;height: 40px;line-height: 40px;">设备信息</div>
            </el-col>
            <el-col :xs="24">
                <el-table :data="deviceinfoData" id="table" :show-header="false" size="mini" border
                    :span-method="arraySpanMethod" :row-style="{ height: '20px' }" style="font-size:10px;">
                    <el-table-column prop="prop1" width="70"></el-table-column>
                    <el-table-column prop="prop2">
                        <template slot-scope="scope">
                            <span v-if="scope.row.prop1 === '所属部门' && scope.row.prop2">
                                {{ scope.row.prop2 }}
                                <el-button type="text" size="mini" style="padding:0;margin-left:4px;" @click="goUsageRecord">使用记录</el-button>
                            </span>
                            <span v-else>{{ scope.row.prop2 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="prop3" width="70"></el-table-column>
                    <el-table-column prop="prop4">
                        <template slot-scope="scope">
                            <span v-if="scope.row.statusValue" :style="{ color: getStatusColor(scope.row.statusValue) }">{{ scope.row.prop4 }}</span>
                            <span v-else>{{ scope.row.prop4 }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        
        <!-- 设备附件显示 -->
        <el-row v-if="deviceDocData.length > 0">
            <el-col :xs="24">
                <div style="padding: 10px;">
                    <div v-for="(item, index) in deviceDocData" :key="index" style="margin-bottom: 15px;">
                        <div style="font-size: 12px; font-weight: bold; color: #666; margin-bottom: 8px;text-align: left; margin-top: 10px;">
                            {{ item.type }}
                        </div>
                        <img v-if="isImageFile(item.path)" 
                             :src="item.path" 
                             :alt="item.name"
                             style="max-width: 100%; height: auto; border: 1px solid #ddd; border-radius: 4px;"
                             @click="previewImage(item.path)">
                        <div v-else-if="isPdfFile(item.path)" 
                             style="padding: 10px; background-color: #f5f5f5; border: 1px solid #ddd; border-radius: 4px; text-align: center; cursor: pointer;"
                             @click="previewImage(item.path)">
                            <i class="el-icon-document" style="font-size: 24px; color: #f56c6c;"></i>
                            <div style="margin-top: 5px; font-size: 12px; color: #666;">PDF文档</div>
                        </div>
                        <div v-else-if="isWordFile(item.path)" 
                             style="padding: 10px; background-color: #f5f5f5; border: 1px solid #ddd; border-radius: 4px; text-align: center; cursor: pointer;"
                             @click="previewImage(item.path)">
                            <i class="el-icon-document" style="font-size: 24px; color: #409EFF;"></i>
                            <div style="margin-top: 5px; font-size: 12px; color: #666;">Word文档</div>
                        </div>
                        <div v-else-if="isExcelFile(item.path)" 
                             style="padding: 10px; background-color: #f5f5f5; border: 1px solid #ddd; border-radius: 4px; text-align: center; cursor: pointer;"
                             @click="previewImage(item.path)">
                            <i class="el-icon-document" style="font-size: 24px; color: #67C23A;"></i>
                            <div style="margin-top: 5px; font-size: 12px; color: #666;">Excel文档</div>
                        </div>
                        <div v-else 
                             style="padding: 10px; background-color: #f5f5f5; border: 1px solid #ddd; border-radius: 4px; text-align: center; cursor: pointer;"
                             @click="previewImage(item.path)">
                            <i class="el-icon-document" style="font-size: 24px; color: #909399;"></i>
                            <div style="margin-top: 5px; font-size: 12px; color: #666;">其他文档</div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { selectDeviceinfoByid,  selectDeviceinfoDocScan, getUsageJumpUrl } from "../../api/api"
export default {
    data() {
        return {
            id: 0,
            sydw: "", // 所属部门编码
            deviceDocData: [], // 设备附件数据
            deviceinfoData: [{
                prop1: "资产名称",
                prop2: "",
                prop3: '',
                spanConfig: { 
                    col1: { rowspan: 1, colspan: 1 },
                    col2: { rowspan: 1, colspan: 3 },
                    col3: { rowspan: 0, colspan: 0 },
                    col4: { rowspan: 0, colspan: 0 }
                }
            }, {
                prop1: "设备编号",
                prop2: "",
                spanConfig: { 
                   col1: { rowspan: 1, colspan: 1 },
                    col2: { rowspan: 1, colspan: 3 },
                    col3: { rowspan: 0, colspan: 0 },
                    col4: { rowspan: 0, colspan: 0 }
                }
            }, {
                prop1: "生产厂家",
                prop2: "",
                spanConfig: { 
                   col1: { rowspan: 1, colspan: 1 },
                    col2: { rowspan: 1, colspan: 3 },
                    col3: { rowspan: 0, colspan: 0 },
                    col4: { rowspan: 0, colspan: 0 }
                }
            }, {
                prop1: "出厂编号",
                prop2: "",
                spanConfig: { 
                    col1: { rowspan: 1, colspan: 1 },
                    col2: { rowspan: 1, colspan: 3 },
                    col3: { rowspan: 0, colspan: 0 },
                    col4: { rowspan: 0, colspan: 0 }
                }
            }, {
                prop1: "规格型号",
                prop2: "",
                spanConfig: { 
                   col1: { rowspan: 1, colspan: 1 },
                    col2: { rowspan: 1, colspan: 3 },
                    col3: { rowspan: 0, colspan: 0 },
                    col4: { rowspan: 0, colspan: 0 }
                }
            },
            {
                prop1: "测量范围",
                prop2: "",
                prop3: "精度",
                prop4: "",
                spanConfig: { 
                    col1: { rowspan: 1, colspan: 1 },
                    col2: { rowspan: 1, colspan: 1 },
                    col3: { rowspan: 1, colspan: 1 },
                    col4: { rowspan: 1, colspan: 1 }
                }
            },
            {
                prop1: "购置日期",
                prop2: "",
                prop3: "设备状态",
                prop4: "",
                spanConfig: { 
                    col1: { rowspan: 1, colspan: 1 },
                    col2: { rowspan: 1, colspan: 1 },
                    col3: { rowspan: 1, colspan: 1 },
                    col4: { rowspan: 1, colspan: 1 }
                }
            },
            {
                prop1: "检定日期",
                prop2: "",
                prop3: "有效期",
                prop4: "",
                spanConfig: { 
                    col1: { rowspan: 1, colspan: 1 },
                    col2: { rowspan: 1, colspan: 1 },
                    col3: { rowspan: 1, colspan: 1 },
                    col4: { rowspan: 1, colspan: 1 }
                }
            }, {
                prop1: "所属部门",
                prop2: "",
                prop3: "保管人",
                prop4: "",
                spanConfig: { 
                    col1: { rowspan: 1, colspan: 1 },
                    col2: { rowspan: 1, colspan: 1 },
                    col3: { rowspan: 1, colspan: 1 },
                    col4: { rowspan: 1, colspan: 1 }
                }
            }, {
                prop1: "存放地点",
                prop2: "",
                spanConfig: { 
                    col1: { rowspan: 1, colspan: 1 },
                    col2: { rowspan: 1, colspan: 3 },
                    col3: { rowspan: 0, colspan: 0 },
                    col4: { rowspan: 0, colspan: 0 }
                }
            }]
        }
    },
    created() {
        this.getPath();
    },
    methods: {
        // 合并单元格 - 基于数据配置
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            const rowData = this.deviceinfoData[rowIndex]
            if (!rowData || !rowData.spanConfig) {
                return { rowspan: 1, colspan: 1 }
            }
            
            // 映射列索引到配置键名
            const colMap = {
                0: 'col1', // 第一列: prop1
                1: 'col2', // 第二列: prop2  
                2: 'col3', // 第三列: prop3
                3: 'col4'  // 第四列: prop4
            }
            
            const colKey = colMap[columnIndex]
            if (colKey && rowData.spanConfig[colKey]) {
                return rowData.spanConfig[colKey]
            }
            
            return { rowspan: 1, colspan: 1 }
        },
        // 查询设备信息
        getDeviceinfoByid() {
            selectDeviceinfoByid(this.id).then(datas => {
                let { status, message, data } = datas
                if (status == 200) {
                    this.sydw = data.sydw || "";
                    // 合并数据赋值
                    const assignments = [
                        { index: 0, props: { prop2: data.zcmc } },
                        { index: 1, props: { prop2: data.glbh } },
                        { index: 2, props: { prop2: data.sccj } },
                        { index: 3, props: { prop2: data.ccbh } },
                        { index: 4, props: { prop2: data.sbxh } },
                        { index: 5, props: { prop2: data.clfw, prop4: data.cljd } },  //测量范围
                        { index: 6, props: { prop2: data.cgrq, prop4: this.getStatusText(data.sbzt), statusValue: data.sbzt } }, //采购日期
                        { index: 7, props: { prop2: data.jdrq, prop4: data.syts } }, //检定日期
                        { index: 8, props: { prop2: data.companyname, prop4: data.bgr } },
                        { index: 9, props: { prop2: data.cfdd } }
                    ]
                    
                    // 批量赋值
                    assignments.forEach(item => {
                        Object.assign(this.deviceinfoData[item.index], item.props)
                    })
                    
                    // 处理剩余天数计算
                    let nowTime = new Date().getTime()
                    let nextTime = new Date(data.xcjdrq).getTime()
                    if (data.xcjdrq) {
                        this.deviceinfoData[7].prop4 = Math.round((nextTime - nowTime) / (1000 * 60 * 60 * 24)) + "天"
                    } else {
                        this.deviceinfoData[7].prop4 = ""
                    }
                }
                this.getDeviceDoc()
            })
        },
        // 跳转使用记录
        goUsageRecord() {
            if (!this.sydw) {
                this.$message.warning("缺少部门信息");
                return;
            }
            getUsageJumpUrl(this.sydw).then(datas => {
                let { status, message, data } = datas;
                if (status != 200) {
                    this.$message.warning(message || "未配置使用记录跳转地址");
                    return;
                }
                let url = data;
                if (url && url.indexOf("{id}") != -1) {
                    url = url.replace("{id}", this.id);
                }
                window.open(url, "_blank");
            });
        },
          // 查找设备资料
        getDeviceDoc() {
            let _params = {
                deviceId: this.id,
            }
            let _this = this
            selectDeviceinfoDocScan(_params).then(datas => {
                let { status, data, message } = datas
                if (status == 200) {
                    _this.deviceDocData = data.map(item => ({
                        ...item,
                        path: _this.toRelativeUrl(item.path)
                    }))
                }
            })
        },
        // 去除URL前面的协议、域名和端口，返回相对路径
        toRelativeUrl(url) {
            if (!url) return url
            return url.replace(/^(https?:)?\/\/[^\/]+/, '')
        },
        // 文件类型检测方法
        isImageFile(filePath) {
            if (!filePath) return false
            const pathLower = filePath.toLowerCase()
            const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg']
            return imageExtensions.some(ext => pathLower.endsWith(ext))
        },
        isPdfFile(filePath) {
            if (!filePath) return false
            return filePath.toLowerCase().endsWith('.pdf')
        },
        isWordFile(filePath) {
            if (!filePath) return false
            const pathLower = filePath.toLowerCase()
            return pathLower.endsWith('.doc') || pathLower.endsWith('.docx')
        },
        isExcelFile(filePath) {
            if (!filePath) return false
            const pathLower = filePath.toLowerCase()
            return pathLower.endsWith('.xls') || pathLower.endsWith('.xlsx')
        },
        // 文件预览（支持微信浏览器）
        previewImage(fileUrl) {
            // 在微信中直接打开链接，微信会自动处理文件类型
            // 对于非图片文件，微信会提示下载或使用其他应用打开
            window.open(fileUrl, '_blank')
        },
        // 获取设备状态文字描述
        getStatusText(status) {
            const statusMap = {
                1: "准用",
                3: "待审核",
                4: "报废",
                40: "待维保",
                41: "停用(待检定)",
                42: "调拨",
                43: "停用(待校准)",
                44: "停用(待核查)",
                45: "降级使用",
                48: "待提交"
            }
            return statusMap[status] || "未知状态"
        },
        // 获取设备状态颜色
        getStatusColor(status) {
            const colorMap = {
                1: "rgb(1, 103, 60)",
                3: "#ffa500",
                4: "#ff4444",
                40: "#ffa500",
                41: "#ff6666",
                42: "#00bcd4",
                43: "#ff6666",
                44: "#ff6666",
                45: "#9c27b0",
                48: "#607d8b"
            }
            return colorMap[status] || "rgb(84, 130, 110)"
        },
        // 获取url传来的参数id
        getPath() {
            this.id = window.location.hash.split("?")[1].split("=")[1]
            this.getDeviceinfoByid();
        },
        checkMonth(i) {
            if (i < 10) {
                i = "0" + i;
            }
            return i;
        },

    },
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/views/device/DeviceinfoByPhone.vue